// Backend API base URL.
//
// Resolved in priority order so a single build can be promoted (staging ->
// production) via a slot-specific setting, with no rebuild:
//   1. window._env_.DATABASE_SERVER  -> runtime config (see public/env-config.js),
//      generated per App Service slot at startup. Survives a slot swap when set
//      as a slot-sticky (deployment slot) setting. Use this for the swap workflow.
//   2. process.env.REACT_APP_DATABASE_SERVER -> build-time value (CRA inlines this
//      at `npm run build`). Use when you build separately per environment.
//   3. Hardcoded production default -> last-resort fallback.
const runtimeEnv = (typeof window !== 'undefined' && window._env_) || {};

const databaseServer =
  runtimeEnv.DATABASE_SERVER ||
  process.env.REACT_APP_DATABASE_SERVER ||
  'https://compucycle-backend-bzgxhuapegezgyd5.centralus-01.azurewebsites.net';

module.exports = {
    databaseServer
}
